
import { Component, Prop, Vue } from "vue-property-decorator";
import { IReport } from "@/modules/Report/interfaces/report.interface";
import { IMovementsReport } from "@/modules/Report/Movements/interfaces/movements-report.interface";
import { openMediaPopup } from "@/modules/Report/Movements/helpers/open-media-popup";
import ChangeMovementActionBtn from "@/modules/Report/Movements/components/specialComponents/ChangeMovementActionBtn.vue";
import ActionsDropdown from "@/modules/Report/Movements/components/specialComponents/ActionsDropdown.vue";

@Component({
  components: {
    ChangeMovementActionBtn,
    ActionsDropdown,
  }
})
export default class ActionsCell extends Vue {
  @Prop() cell: IReport.ITableProp;
  @Prop() entity: IMovementsReport.IDataItem;
  @Prop() index: number;
  @Prop() tableList: IMovementsReport.IDataItem[];
  @Prop() fromCarPopup!: boolean;
  @Prop() fromSelectMovePopup!: boolean;

  async openMediaPopup() {
    const payload = {
      item: this.entity,
      index: this.index,
      tableList: this.tableList,
      fromCarPopup: this.fromCarPopup || this.fromSelectMovePopup,
    };
    await openMediaPopup(payload);
  }
}
